import React from "react";
import { Link } from "@sscs/ui";
import { getClassName } from "@sscs/utils";
import { matchPath, useSearchParams } from "react-router";
import { REPORT_PAGES_ROUTES } from "../../../constants";
import { scrollTo } from "../../../store/sdlcReportSlice";
import { useReportDispatch, useReportRootPath } from "../../hooks";
import styles from "./linkToReportTab.module.scss";
/** Link to report page from inside the report.
 *
 * @param id HTML id
 * @param to page path relative to the REPORT ROOT (never to the current page),
 *   e.g. `REPORT_PAGES_ROUTES.ISSUES_ROUTE` or `version-diff/file-changes`. Pass
 *   an object to add a search/hash; its `pathname` is still root-relative. An
 *   empty `to` navigates to the REPORT ROOT (summary).
 * @param color link or none
 * @param disabled if link should be disabled. If yes, <span> will be used to render it
 * @param underline when the underline is shown
 * @param fullWidth should link be full width
 * @param inline render the link inline so it flows within surrounding text
 * @param className CSS for the component
 * @param onClick onClick handler
 * @param children
 * @constructor
 */
const LinkToReportTab = ({ id, to, color = "none", disabled = false, underline = "always", fullWidth = false, inline = false, className, "aria-label": ariaLabel, onClick, children, }) => {
    var _a;
    const reportRootPath = useReportRootPath();
    const dispatch = useReportDispatch();
    const [params] = useSearchParams();
    const toPathname = typeof to === "string" ? to : ((_a = to.pathname) !== null && _a !== void 0 ? _a : "");
    const targetPathname = toPathname === ""
        ? reportRootPath || "/"
        : `${reportRootPath}/${toPathname}`;
    const isFuturePathFileBrowser = matchPath({
        path: `${reportRootPath}/${REPORT_PAGES_ROUTES.FILE_BROWSER_ROUTE}`,
        end: false,
    }, targetPathname);
    const classes = getClassName({
        [styles["no-color"]]: color === "none",
    }, className);
    if (disabled)
        return (React.createElement("span", { id: id, className: `${styles.disabled} ${className}` }, children));
    const newSearchParams = new URLSearchParams(params.toString());
    if (!isFuturePathFileBrowser)
        newSearchParams.delete("path");
    const target = typeof to === "string"
        ? { pathname: targetPathname, search: newSearchParams.toString() }
        : { ...to, pathname: targetPathname };
    return (React.createElement(Link, { id: id, to: target, fullWidth: fullWidth, inline: inline, "aria-label": ariaLabel, underline: underline, onClick: () => {
            dispatch(scrollTo(null));
            if (onClick)
                onClick();
        }, preventScrollReset: true, className: classes }, children));
};
export default LinkToReportTab;
//# sourceMappingURL=LinkToReportTab.js.map